import * as tslib_1 from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import ResultSelected from './ResultSelected.vue';
import Result from './Result.vue';
let Results = class Results extends Vue {
    clearFilters() {
        this.$emit('clear-filters');
    }
    toggleSelectedResult(id) {
        this.$emit('toggle-selected-result', id);
    }
    resultShareClick(id) {
        this.$emit('result-share-click', id);
    }
    get resListIsSticky() {
        return this.isSomeResultSelected && this.selectedIsSticky;
    }
    get isSomeResultSelected() {
        return this.selectedMarkerId > 0;
    }
    resetAll() {
        var newUrl = `${window.location.protocol}//${window.location.host}${window.location.pathname}`;
        window.top.location.href = newUrl; // window.location.href = newUrl https://stackoverflow.com/questions/3783639/window-location-href-but-where-the-address-bar-changes
    }
};
tslib_1.__decorate([
    Prop()
], Results.prototype, "isWaiting", void 0);
tslib_1.__decorate([
    Prop()
], Results.prototype, "resultsListForDisplayNotEmpty", void 0);
tslib_1.__decorate([
    Prop()
], Results.prototype, "anyFiltersSelected", void 0);
tslib_1.__decorate([
    Prop()
], Results.prototype, "resultsSubtitle", void 0);
tslib_1.__decorate([
    Prop()
], Results.prototype, "selectedMarkerId", void 0);
tslib_1.__decorate([
    Prop()
], Results.prototype, "selectedResult", void 0);
tslib_1.__decorate([
    Prop()
], Results.prototype, "selectedIsSticky", void 0);
tslib_1.__decorate([
    Prop()
], Results.prototype, "resultsListForDisplay", void 0);
Results = tslib_1.__decorate([
    Component({
        components: {
            ResultSelected,
            Result
        }
    })
], Results);
export default Results;
